import { render, staticRenderFns } from "./ChannelType.vue?vue&type=template&id=47e192af&scoped=true&"
import script from "./ChannelType.vue?vue&type=script&lang=js&"
export * from "./ChannelType.vue?vue&type=script&lang=js&"
import style0 from "./ChannelType.vue?vue&type=style&index=0&id=47e192af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e192af",
  null
  
)

export default component.exports